import { QrCodeIcon } from 'lucide-react';
import { QRCode } from 'react-qrcode-logo';

import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';

interface QRCodeDialogProps {
  documentName: string;
  documentPublicId: string;
}

const QRCodeDialog = ({
  documentName,
  documentPublicId,
}: QRCodeDialogProps) => {
  return (
    <Dialog
      title="QR Code do Documento"
      tooltipContent="Visualizar QR Code do documento"
      trigger={
        <Button variant="outline" size="icon-sm">
          <QrCodeIcon className="h-4 w-4" />
        </Button>
      }
    >
      <div className="flex flex-col items-center justify-center">
        <QRCode
          value={new URL(
            `/docs/${documentPublicId}`,
            window.location.origin,
          ).toString()}
          logoImage="/favicon.svg"
          removeQrCodeBehindLogo
          size={256}
        />

        <p className="mt-4 text-center text-sm text-muted-foreground">
          Escaneie o QR Code para acessar o documento "{documentName}"
          diretamente no seu dispositivo móvel.
        </p>
      </div>
    </Dialog>
  );
};

export default QRCodeDialog;
